import { DEVICE_TYPE, SLIM_DEVICE_TYPE } from "@src/devices/types"
import { callApi } from "../callApi"

export type GET_DEVICE_PARAMS = {
  page?: number
  per_page?: number
  search_string?: string
  sort_by?: string
  sort_desc?: boolean
  servicebooking_status?: "active" | "none"
  servicebooking_end_before?: string
  battery_below?: number
  lock_state?: DEVICE_TYPE["locked"]
  reported_stolen?: boolean
  fleet_uuid?: string[]
  exclude_fleet_uuid?: string[]
}

export type META_PARAMS = {
  page?: number
  per_page?: number
  total?: number
  search_string?: string
  sort_by?: string | null
  sort_desc?: boolean | null
  filter?: {
    servicebooking_end_before?: string
    servicebooking_status?: "active" | "none"
    battery_below?: number
    lock_state?: DEVICE_TYPE["locked"]
    reported_stolen?: boolean
    fleet_uuid?: string[]
    exclude_fleet_uuid?: string[]
  }
}

export type GET_DEVICE_RESPONSE = {
  devices: SLIM_DEVICE_TYPE[]
  meta: META_PARAMS
}

export const getDevice = (partnerUuid: string, fleetUuid?: string, params?: GET_DEVICE_PARAMS) => {
  const processedParams = { ...params }

  // Filter out undefined, null, and empty search strings
  const filteredEntries = Object.entries(processedParams || {}).filter(([key, value]) => {
    if (value === undefined || value === null) return false
    if (key === "search_string" && String(value).trim() === "") return false
    return true
  })

  // Transform entries to handle arrays with bracket notation
  // fleet_uuid = ["aaa", "bbb"] => [["fleet_uuid[]", "aaa"], ["fleet_uuid[]", "bbb"]]
  const entries = filteredEntries.flatMap(([key, value]) => {
    if (Array.isArray(value)) {
      return value.map((item) => [`${key}[]`, item])
    }
    return [[key, value]]
  })

  const queryString = entries
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join("&")

  const urlPath = fleetUuid
    ? `/partner/${partnerUuid}/fleets/${fleetUuid}/devices?${queryString}`
    : `/partner/${partnerUuid}/device?${queryString}`

  return callApi<null, GET_DEVICE_RESPONSE>({ method: "GET", path: urlPath })
}
